import Immutable from 'seamless-immutable';

import { register } from '@src/dispatcher';
import createStore from '@src/stores/StoreUtils';
import ACTION_TYPES from './actionTypes';

class Store {
  state = Immutable({
    entityList: [],
    transitionEntityList: [],
    transitionValueData: [],
    transitionUserResponses: [],
    rules: [{}],
    clause: 'AND',
    outputJson: {},
    connectionFrom: {},
    connectionTo: {},
    domainSynonyms: {},
    nodeEntities: {},
    edited: false,
    isValid: true,
    biDirectional: false,
    isDomainSynonymsEdited: false,
    isNodeEntitiesEdited: false,
  });

  constructor() {
    this.reducer = this.reducer.bind(this);
    this.registrer = this.registrer.bind(this);
    this.getState = this.getState.bind(this);
    this.getStateImmutable = this.getStateImmutable.bind(this);
    this._Store = createStore(this.state);
    this._Store.dispatchToken = register(this.registrer);
  }

  registrer(props) {
    this.state = this.reducer(props);
    this._Store.emitChange();
  }

  reducer({ action, type: actionType }) {
    const { state } = this;
    switch (actionType) {
      case ACTION_TYPES.RECEIVED_CONNECTION_DATA:
        return state.merge({ ...action, edited: false });

      case ACTION_TYPES.UPDATE_CONNECTION_DATA:
        return state.merge({ ...action, edited: true });

      case ACTION_TYPES.SAVE_CONNECTION_DATA:
        return state.merge({
          edited: false,
          isDomainSynonymsEdited: false,
          isNodeEntitiesEdited: false,
        });

      case ACTION_TYPES.RESET_DATA:
        return state.merge({
          edited: false,
          isValid: true,

          entityList: [],
          transitionEntityList: [],
          transitionValueData: [],
          transitionUserResponses: [],
          rules: [{}],
          clause: 'AND',

          outputJson: {},
          connectionFrom: {},
          connectionTo: {},
          domainSynonyms: {},
          nodeEntities: {},
          biDirectional: false,
          isDomainSynonymsEdited: false,
          isNodeEntitiesEdited: false,
        });

      default:
        return state;
    }
  }

  getState() {
    return this.state;
  }

  getStateImmutable() {
    return this.state;
  }

  getStore() {
    return this._Store;
  }
}

export default new Store();
